import React, { PureComponent } from "react";
import Modal from "../Modal";
import "./index.less";
export default class Photo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      scale: false
    };
  }

  onClose() {
    this.setState({
      scale: false
    });
  }

  onShow() {
    this.setState({
      scale: true
    });
  }

  render() {
    const { scale } = this.state;
    const { value, opts = {} } = this.props;
    const { width = "500", height = "auto" } = opts;
    return (
      <span className="TUI-Photo">
        <img src={value} onClick={this.onShow.bind(this)} />
        {scale ? (
          <Modal
            width={544}
            title=""
            visible={scale}
            onOk={this.onClose.bind(this)}
            onCancel={this.onClose.bind(this)}
            footer={null}
            wrapClassName="TUI-Photo-Modal"
          >
            <img src={value} alt="" width={width} height={height} />
          </Modal>
        ) : null}
      </span>
    );
  }
}
